
<script setup>

  import { ref, onMounted } from 'vue';

  import SplashTitle from '../partials/splash-title.vue';

  import SplashIntroduction from '../partials/splash-introduction.vue';

  import SplashBackground from '../partials/splash-background.vue';

  import backgroundPaths from '../images/splash-background-*.jpg';

  const titleRef = ref( null );

  const showIntroduction = ref( false );

  const backgroundRefs = ref( [] );
  
  onMounted( () => titleRef.value.animate() );

  function onTitleNext() {

    setTimeout( () => showIntroduction.value = true, 2000 );

    backgroundRefs.value[ 0 ].animate();

  }

</script>

<template>

  <section>
    
    <div class="grid min-h-view">

      <SplashBackground
      
        v-for="( path, key ) in backgroundPaths" :duration="14000"
      
        class="row-start-1 col-start-1" :path="path" ref="backgroundRefs"
        
        @next="backgroundRefs[ parseInt( key ) % backgroundRefs.length ].animate()" />

      <SplashTitle
      
        :duration="4000"

        :class="[ 'row-start-1 col-start-1 transition-[opacity,visibility] duration-1000',
        
          showIntroduction ? 'opacity-0 invisible' : 'opacity-100 visible' ]"
      
        ref="titleRef" @next="onTitleNext" />

      <SplashIntroduction
      
        :class="[ 'row-start-1 col-start-1 transition-[opacity,visibility] duration-1000',
        
          showIntroduction ? 'opacity-100 visible' : 'opacity-0 invisible' ]" />

    </div>

  </section>

</template>
